var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "jade-stepper-item" },
    [
      _c("jade-icon", {
        attrs: { size: "large", use: _vm.icon, color: _vm.computedColor },
      }),
      _c(
        "jade-text",
        {
          attrs: {
            size: "large",
            weight: "semibold",
            variant: "text-large",
            color: _vm.computedColor,
          },
        },
        [_vm._v(" " + _vm._s(_vm.name))]
      ),
      _vm.hasNext
        ? _c("jade-icon", {
            staticClass: "jade-stepper-item--arrow",
            attrs: { color: _vm.computedColor, use: "chevron-right" },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }